import { subscribe } from "../../store/modules/client/index";
import React, { useState } from "react";
import { Link, useUrl } from "@shopify/hydrogen";
import { Form, Formik, Field } from "formik";
import * as Yup from "yup";
import Button from "../elements/Button";
import {
  YoutubeIcon,
  FacebookIcon,
  InstagramIcon,
  ChevronIcon,
} from "../elements/Icon";
import Dropdown from "../elements/Dropdown";
import { footerData } from "./footerData";

const Footer = () => {
  const [activeField, setActiveField] = useState("");
  const [loading, setLoading] = useState(false);
  const SubmitSchema = Yup.object().shape({
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email is required"),
  });

  const handleSubmit = async (payload) => {
    setLoading(true);
    await subscribe(payload);
    setLoading(false);
  };

  const [showOptions, setShowOptions] = useState(false);
  const handleClick = () => {
    setShowOptions(!showOptions);
  };

  // function validateEmail(value) {
  //   let error;
  //   if (!value) {
  //     error = 'Required';
  //   } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
  //     error = 'Invalid email address';
  //   }
  //   return error;
  // }

  const{pathname} = useUrl()

  return (
    <footer className={`${pathname === "/dashboard" && "hidden"}`}>
      <div className="w-full">
        <div className="flex-col justify-center text-[#2A3238] bg-[#F2F2EB]">
          <div className="lg:flex justify-between items-center gap-3 w-full text-center mx-auto max-w-[450px] lg:max-w-[924px] py-5 lg:py-6 lg:mx-auto">
            <h4 className="md:text-[20px] text-base w-full lg:max-w-[490px] max-w-full mx-auto font-gotham-bold text-left lg:px-0 px-4">
              Sign up for news, promotions and more.
            </h4>
            <div className="flex-col items-center justify-center w-full lg:max-w-[450px] mx-auto lg:px-0 px-4">
              <Formik
                initialValues={{ email: "" }}
                validationSchema={SubmitSchema}
                onSubmit={(values, { resetForm }) => {
                  handleSubmit(values);
                  resetForm({ values: "" });
                }}
              >
                {({ errors, values, touched, setFieldTouched }) => (
                  <Form className="flex-row items-end justify-between w-full gap-5 lg:flex">
                    <div className="w-full relative mx-auto lg:max-w-[240px] max-w-full lg:mt-0 mt-3 h-[37px]">
                      <Field
                        name="email"
                        className={`h-full pt-[11px] pb-0 px-[10px] w-full border-b font-gotham-bold text-[14px] placeholder:text-[#2A3238] border-w-8 border-[#3B4458] focus:outline-none bg-transparent ${
                          errors.email ? "border-red-400" : "border-gray-300"
                        }`}
                        onFocus={() => {
                          setActiveField("email");
                        }}
                        onBlur={() => {
                          setFieldTouched("email", true);
                          setActiveField("");
                        }}
                      />
                      <span
                        className={`absolute pointer-events-none transition-all duration-200 px-[10px] left-0 top-[8px] ${
                          values.email.length > 0 || activeField == "email"
                            ? "translate-y-[-9px] text-[10px]"
                            : "translate-y-[0px] text-[14px]"
                        }`}
                      >
                        Enter your email address
                      </span>
                      {errors.email && touched.email && (
                        <span className="absolute flex pt-[3px] pl-[12px] text-[10px] text-red-400 font-gotham-light pointer-events-none">
                          {errors.email}
                        </span>
                      )}
                    </div>
                    <div className="flex items-center justify-end mt-6 lg:mt-0">
                      <Button
                        text={"SUBMIT"}
                        disabled={false}
                        loading={loading ? true : undefined}
                        type="submit"
                        className="text-xs font-gotham-bold border border-[#0C2340] focus:outline-none bg-transparent lg:w-[176px] w-full h-[37px]"
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
        <div className="bg-[#570054] text-[#F2F2EB] md:h-[335px] h-full md:flex  md:px-0 w-full">
          <div className="lg:min-w-[924px] mx-auto md:flex hidden justify-between items-start mt-10">
            {footerData.map((item, i) => (
              <div
                key={i}
                className="w-[176px] flex justify-start items-start flex-col"
              >
                <h2 className="text-lg uppercase font-gotham-bold">
                  {item.mainHeading}
                </h2>
                <div className="flex-col mt-4">
                  {item.subHeaders.map((subItem, index) => (
                    <React.Fragment key={index}>
                      <Link
                        target={subItem.target ? "_blank" : "_self"}
                        to={subItem.link}
                        className="text-[14px] hover:underline mb-4 font-gotham-light block"
                      >
                        {subItem.title}
                      </Link>
                    </React.Fragment>
                  ))}
                  {item?.icons && (
                    <>
                      <div className="flex items-center gap-3 pt-4">
                        <a
                          href="https://web.facebook.com/LivCyclingSA/"
                          target="_blank"
                        >
                          <FacebookIcon />
                        </a>
                        <a
                          href=" https://www.instagram.com/livcyclingrsa/"
                          target="_blank"
                        >
                          <InstagramIcon />
                        </a>
                        {/* <a
                    href="https://www.youtube.com/channel/UCjp_AF96ltaGUMKy3di_3ZA"
                    target="_blank"
                  >
                    <YoutubeIcon />
                  </a> */}
                      </div>
                      <div className="pt-7">
                        <Link to="/">
                          <img
                            src="https://cdn.shopify.com/s/files/1/0718/1094/1242/files/Group.png?v=1676540076"
                            alt=""
                          />
                        </Link>
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="flex flex-col pt-5 md:hidden ">
            <Dropdown features="Features" featuresOptions />
            <Dropdown support="Support" supportOptions />
            <Dropdown company="Company" companyOptions />
            <Dropdown contact="Contact Us" contactOptions />
          </div>
          <div className="md:hidden  flex bg-[#570054]  text-[#BABDC4] px-8 ">
            <div className="flex items-center justify-between w-full px-4 pb-10 mt-10 md:hidden">
              <Link to="/">
                <img
                  src="https://cdn.shopify.com/s/files/1/0718/1094/1242/files/Group.png?v=1676540076"
                  alt=""
                />
              </Link>
              <div className="flex justify-between gap-5">
                <a href="https://www.facebook.com/LivCyclingSA" target="_blank">
                  <FacebookIcon />
                </a>
                <a
                  href="https://www.instagram.com/livcyclingrsa/"
                  target="_blank"
                >
                  <InstagramIcon />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#3B4458] py-4 w-full flex md:flex-row flex-col items-center text-center justify-center md:gap-1 gap-0 md:text-sm text-[10px] text-[#BABDC4] font-gotham-bold">
        <h4>
          ©{new Date().getFullYear()} Iris Brands (Pty) Ltd. Official
          distributor of Liv in South Africa.
        </h4>
        <div className="flex items-center justify-center gap-1">
          <Link to="/privacy" className="underline font-gotham-bold">
            Privacy Policy
          </Link>
          <span>/</span>
          <Link to="/terms" className="underline font-gotham-bold">
            Terms of Use
          </Link>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
